import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { AppData } from '@shared/models/appdata.model';
import { MbbSubscriptionOffering, MbbRouter } from '../models/mbb-offerings-response.model';

@Injectable({
  providedIn: 'root',
})
export class MbbService {
  private http = inject(HttpClient);
  private appData = inject(AppData);

  getAllMbbProductOfferings() {
    const uri = `${this.appData.apiUrl}/api/v1/product/mobileBroadband/offerings`;
    return this.http.get<MbbSubscriptionOffering[]>(uri, { headers: { 'cache-control': 'no-cache' } });
  }

  getAllMbbRouters() {
    const uri = `${this.appData.apiUrl}/api/v1/product/mobileBroadband/routers`;
    return this.http.get<MbbRouter[]>(uri, { headers: { 'cache-control': 'no-cache' } });
  }
}
